import { loadModules } from 'esri-loader';
import { LINK_MAPS } from 'src/util/Util';
import i18n from 'src/i18n';

const importRequire = [
  'esri/Map',
  'esri/views/MapView',
  'esri/layers/KMLLayer',
  'esri/Graphic',
  'esri/widgets/Measurement',
  'esri/widgets/LayerList',
  'esri/layers/GraphicsLayer',
  'esri/widgets/Expand',
  'esri/widgets/Sketch',
  'esri/widgets/Print',
  'esri/layers/FeatureLayer',
  'esri/layers/Layer',
  'esri/widgets/Home',
  'esri/widgets/Fullscreen',
  'esri/widgets/BasemapGallery',
  'esri/intl',
];

const importBaseMap = [
  'esri/Map',
  'esri/views/MapView',
  'esri/Graphic',
  'esri/geometry/Point',
  'esri/symbols/PictureMarkerSymbol',
  'esri/layers/KMLLayer',
  'esri/widgets/ScaleBar',
  'esri/widgets/Fullscreen',
  'esri/widgets/BasemapGallery',
  'esri/widgets/Expand',
  'esri/widgets/Home',
  'esri/widgets/Print',
  'esri/widgets/Measurement',
  'esri/widgets/Sketch',
  'esri/layers/GraphicsLayer',
  'esri/widgets/LayerList',
  'esri/layers/FeatureLayer',
  'esri/Color',
  'esri/intl',
];

const importHeatMap = [
  'esri/Map',
  'esri/views/MapView',
  'esri/layers/FeatureLayer',
  'esri/layers/KMLLayer',
  'esri/widgets/ScaleBar',
  'esri/widgets/Fullscreen',
  'esri/widgets/BasemapGallery',
  'esri/widgets/Expand',
  'esri/widgets/Home',
  'esri/widgets/Print',
  'esri/widgets/Legend',
  'esri/widgets/Measurement',
  'esri/widgets/Sketch',
  'esri/layers/GraphicsLayer',
  'esri/widgets/LayerList',
  'esri/intl',
];

const importMapRegistrationForm = [
  'esri/Map',
  'esri/views/MapView',
  'esri/Graphic',
  'esri/geometry/Point',
  'esri/symbols/PictureMarkerSymbol',
  'esri/widgets/ScaleBar',
  'esri/widgets/Fullscreen',
  'esri/widgets/Home',
  'esri/widgets/Locate',
  'esri/widgets/Search',
  'esri/widgets/CoordinateConversion',
  'esri/views/SceneView',
  'esri/intl',
];

const importMapMultipleC = [
  'esri/Map',
  'esri/views/MapView',
  'esri/Graphic',
  'esri/geometry/Point',
  'esri/symbols/PictureMarkerSymbol',
  'esri/layers/KMLLayer',
  'esri/widgets/ScaleBar',
  'esri/widgets/Fullscreen',
  'esri/widgets/BasemapGallery',
  'esri/widgets/Expand',
  'esri/widgets/Home',
  'esri/widgets/Print',
  'esri/widgets/Measurement',
  'esri/widgets/Sketch',
  'esri/layers/GraphicsLayer',
  'esri/widgets/LayerList',
  'esri/widgets/CoordinateConversion',
  'esri/intl',
];

const importMapProduction = [
  'esri/Map',
  'esri/views/MapView',
  'esri/layers/FeatureLayer',
  'esri/Graphic',
  'esri/geometry/Point',
  'esri/symbols/PictureMarkerSymbol',
  'esri/layers/KMLLayer',
  'esri/widgets/ScaleBar',
  'esri/widgets/Fullscreen',
  'esri/widgets/BasemapGallery',
  'esri/widgets/Expand',
  'esri/widgets/Home',
  'esri/widgets/Print',
  'esri/widgets/Measurement',
  'esri/widgets/Sketch',
  'esri/layers/GraphicsLayer',
  'esri/widgets/LayerList',
  'esri/widgets/Legend',
  'esri/intl',
];

const importMapClima = [
  'esri/Map',
  'esri/views/MapView',
  'esri/layers/FeatureLayer',
  'esri/Graphic',
  'esri/geometry/Point',
  'esri/symbols/PictureMarkerSymbol',
  'esri/layers/KMLLayer',
  'esri/widgets/ScaleBar',
  'esri/widgets/Fullscreen',
  'esri/widgets/BasemapGallery',
  'esri/widgets/Expand',
  'esri/widgets/Home',
  'esri/widgets/Print',
  'esri/widgets/Measurement',
  'esri/widgets/Sketch',
  'esri/layers/GraphicsLayer',
  'esri/widgets/LayerList',
  'esri/widgets/Legend',
  'esri/intl',
];

const MixinArcgisMap = {
  methods: {
    /**
     * Metodo encargado de graficar un mapa mostrando el recorrido que se
     * realizo y graficando los puntos donde capturo una plaga o enfermedad
     * @param {*} nameKml
     * @param {*} pointsData
     * @param {*} center
     * @param {*} showMeasurement
     * @param {*} layersList
     * @param {*} mapRef
     * @param {*} zoom
     * @param {*} anomalyPoints
     */
    loadTrackMap(
      nameKml,
      pointsData,
      center,
      showMeasurement = false,
      layersList = false,
      mapRef = null,
      zoom = null,
      anomalyPoints = []
    ) {
      loadModules(importRequire)
        .then(
          ([
            Map,
            MapView,
            KMLLayer,
            Graphic,
            Measurement,
            LayerList,
            GraphicsLayer,
            Expand,
            Sketch,
            Print,
            FeatureLayer,
            Layer,
            Home,
            Fullscreen,
            BasemapGallery,
            intl,
          ]) => {
            intl.setLocale(i18n.locale.toLowerCase());
            const measurement = new Measurement();
            let map;
            if (showMeasurement) {
              var graphicsLayer = new GraphicsLayer({
                title: i18n.t('uti.mixinArcgisMap.graphicsLayer'),
              });
            }

            if (nameKml != null) {
              let layer = [];
              if (Array.isArray(nameKml)) {
                nameKml.forEach((element) => {
                  layer.push(
                    new KMLLayer({
                      url: LINK_MAPS + element + '/Perimetro.kml',
                    })
                  );
                });
              } else {
                layer.push(
                  new KMLLayer({
                    url: LINK_MAPS + nameKml + '/Perimetro.kml',
                  })
                );
              }
              map = new Map({
                basemap: 'hybrid',
                layers: layer,
              });
            } else {
              if (showMeasurement) {
                map = new Map({
                  basemap: 'hybrid',
                  layers: [graphicsLayer],
                });
              } else {
                map = new Map({
                  basemap: 'hybrid',
                });
              }
            }

            if (mapRef == null) {
              mapRef = this.$refs.routeMap;
            }

            let pointCenters = [];
            let centerOfAllPoints = null;

            if (anomalyPoints.length > 0) {
              anomalyPoints.forEach((element) => {
                pointCenters.push({
                  lat: parseFloat(element.latitude),
                  lng: parseFloat(element.longitude),
                });
              });
              centerOfAllPoints = this.getCenterExtend(pointCenters);
            }
            let zoomCenter =
              zoom != null && centerOfAllPoints != null ? zoom : 12;

            this.map = new MapView({
              container: mapRef,
              map: map,
              zoom: zoomCenter,
              center: [
                parseFloat(
                  centerOfAllPoints ? centerOfAllPoints.lng : center.lng
                ),
                parseFloat(
                  centerOfAllPoints ? centerOfAllPoints.lat : center.lat
                ),
              ],
            });

            const polylines = [];
            pointsData.forEach((data, index) => {
              polylines.push({
                polyline: {
                  type: 'polyline',
                  paths: [],
                },
                dateD: `${data.points[0].full_date} - ${
                  data.points[data.points.length - 1].full_date
                }`,
                init: [data.points[0].longitude, data.points[0].latitude],
                end: [
                  data.points[data.points.length - 1].longitude,
                  data.points[data.points.length - 1].latitude,
                ],
                user: data.user,
                code: data.code,
              });

              data.points.forEach((point) => {
                polylines[index].polyline.paths.push([
                  parseFloat(point.longitude),
                  parseFloat(point.latitude),
                ]);
              });
            });

            polylines.forEach((polyline, index) => {
              const polylineGraphic = new Graphic({
                geometry: polyline.polyline,
              });

              const renderer = {
                type: 'simple',
                symbol: {
                  color: '#E27728',
                  type: 'simple-line',
                  width: 3,
                  outline: {
                    style: 'solid',
                    color: '#E27728',
                    width: 3,
                  },
                },
              };

              let feature = new FeatureLayer({
                title: `${polyline.dateD}`,
                source: [polylineGraphic],
                renderer: renderer,
                fields: [
                  {
                    name: 'ObjectID',
                    alias: 'ObjectID',
                    type: 'oid',
                  },
                  {
                    name: 'place',
                    alias: 'Place',
                    type: 'string',
                  },
                ],
                objectIdField: 'ObjectID',
                geometryType: 'polyline',
              });

              const initIcon = new Graphic({
                geometry: {
                  type: 'point',
                  longitude: parseFloat(polyline.init[0]),
                  latitude: parseFloat(polyline.init[1]),
                },
                symbol: {
                  type: 'simple-marker',
                  color: '#0032FF',
                  outline: {
                    style: 'solid',
                    color: [226, 119, 40, 0],
                    width: 4,
                  },
                },
              });

              const endIcon = new Graphic({
                geometry: {
                  type: 'point',
                  longitude: polyline.end[0],
                  latitude: polyline.end[1],
                },
                symbol: {
                  type: 'simple-marker',
                  color: '#ff0000',
                  outline: {
                    style: 'solid',
                    color: [226, 119, 40, 0],
                    width: 4,
                  },
                },
              });

              let deleteRecordingAction = null;
              if (this.isDelete()) {
                deleteRecordingAction = {
                  title: i18n.t('uti.mixinArcgisMap.deleteTour'),
                  id: 'delete-recording',
                  className: 'esri-icon-trash',
                  recordingCode: polyline.code,
                };
              }

              const template = {
                title: i18n.t('uti.mixinArcgisMap.startTour'),
                content: `
                  <br>
                  ${i18n.t('common_words.beginning')}: ${
                  polyline.dateD.split(' - ')[0]
                }
                  <br>
                  ${i18n.t('common_words.user')}: ${polyline.user}
                `,
                actions: deleteRecordingAction ? [deleteRecordingAction] : null,
              };
              initIcon.popupTemplate = template;

              const templateEnd = {
                title: i18n.t('uti.mixinArcgisMap.endTour'),
                content: `
                  <br>
                  ${i18n.t('common_words.beginning')}: ${
                  polyline.dateD.split(' - ')[1]
                }
                  <br>
                  ${i18n.t('common_words.user')}: ${polyline.user}
                `,
                actions: deleteRecordingAction ? [deleteRecordingAction] : null,
              };
              endIcon.popupTemplate = templateEnd;
              map.add(feature);
              this.map.graphics.add(initIcon);
              this.map.graphics.add(endIcon);
            });

            if (Array.isArray(anomalyPoints) && anomalyPoints.length > 0) {
              const anomalyLayer = new GraphicsLayer({
                title: i18n.t('uti.mixinArcgisMap.layer_points'),
              });

              anomalyPoints.forEach((point) => {
                const parts = point.code.split('.');
                const dateStr = parts[3];
                const year = parseInt(dateStr.substring(0, 4));
                const month = parseInt(dateStr.substring(4, 6)) - 1;
                const day = parseInt(dateStr.substring(6, 8));
                const date = `${String(day).padStart(2, '0')}/${String(
                  month + 1
                ).padStart(2, '0')}/${year}`;
                const pointGraphic = new Graphic({
                  geometry: {
                    type: 'point',
                    longitude: parseFloat(point.longitude),
                    latitude: parseFloat(point.latitude),
                  },
                  symbol: {
                    type: 'simple-marker',
                    color: point.color || '#D0021B',
                    outline: {
                      color: [255, 255, 255],
                      width: 1.3,
                    },
                  },
                  popupTemplate: {
                    title: `<b>${point.disease_name}</b>`,
                    content: `
                        <b>${i18n.t('common_words.date')}:</b> ${date}<br>
                        <b>${i18n.t('common_words.allotment')}:</b> ${
                      point.lot_name
                    }<br>
                        <b>${i18n.t('common_words.code')}:</b> ${
                      point.code_detail
                    }<br>
                        <b>${i18n.t('common_words.tower')}:</b> ${
                      point.tower
                    }<br>
                        <b>${i18n.t('common_words.cases')}:</b> ${point.cases}`,
                  },
                });

                anomalyLayer.add(pointGraphic);
              });

              this.map.map.add(anomalyLayer);
            }

            if (layersList) {
              this.map.ui.add(
                new Expand({
                  view: this.map,
                  content: new LayerList({
                    view: this.map,
                  }),
                }),
                'top-right'
              );
            }

            if (showMeasurement) {
              this.map.ui.add(
                new Expand({
                  expandIconClass: 'esri-icon-sketch-rectangle',
                  view: this.map,
                  content: new Sketch({
                    layer: graphicsLayer,
                    view: this.map,
                    creationMode: 'update',
                  }),
                }),
                'top-right'
              );

              let activeView = this.map;
              const distanceButton = document.getElementById('distance');
              const areaButton = document.getElementById('area');
              const clearButton = document.getElementById('clear');

              distanceButton.addEventListener('click', function () {
                const type = activeView.type;
                measurement.activeTool =
                  type.toUpperCase() === '2D' ? 'distance' : 'direct-line';
                distanceButton.classList.add('active');
                areaButton.classList.remove('active');
              });

              areaButton.addEventListener('click', function () {
                measurement.activeTool = 'area';
                distanceButton.classList.remove('active');
                areaButton.classList.add('active');
              });

              clearButton.addEventListener('click', function () {
                distanceButton.classList.remove('active');
                areaButton.classList.remove('active');
                measurement.clear();
              });

              measurement.view = activeView;
              this.map.ui.add(measurement, 'top-right');
            }

            this.map.ui.add(
              new Fullscreen({
                view: this.map,
                element: mapRef,
              }),
              'top-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new BasemapGallery({
                  view: this.map,
                }),
              }),
              'top-left'
            );

            this.map.ui.add(
              new Home({
                view: this.map,
              }),
              'top-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new Print({
                  view: this.map,
                  printServiceUrl:
                    'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
                  templateOptions: {
                    legendEnabled: false,
                  },
                }),
              }),
              'top-left'
            );

            this.map.popup.on('trigger-action', (event) => {
              if (event.action.id === 'delete-recording') {
                this.deleteRecordingMap(event.action.recordingCode);
              }
            });

            this.removeLayerUntitled();
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },

    /**
     * Carga y configura un mapa interactivo utilizando la API de ArcGIS.
     * Esta función admite la visualización de puntos, polígonos, mediciones,
     * capas KML y varias herramientas de usuario como medición, impresión,
     * y galería de mapas base.
     *
     * @param {Array|string|null} nameKml - URL(s) del archivo KML para mostrar en el mapa.
     *                                      Puede ser una URL única o un arreglo de URLs.
     * @param {boolean} showMeasurement - Indica si se debe habilitar la herramienta de medición.
     * @param {boolean} layersList - Indica si se debe mostrar la lista de capas en el mapa.
     * @param {HTMLElement|null} mapRef - Referencia al contenedor HTML donde se renderizará el mapa.
     *                                     Si es `null`, se utiliza una referencia por defecto (`this.$refs.map`).
     * @param {Array|null} points - Lista de puntos a mostrar en el mapa.
     *                              Cada punto debe tener las propiedades `lat`, `lng`, `color` y `name`.
     * @param {number|null} zoom - Nivel de zoom inicial del mapa. Si es `null`, se utiliza un valor por defecto (14).
     * @param {Array|null} sickPerimeter - Lista de coordenadas (en formato `[lng, lat]`) para representar un perímetro específico.
     * @param {boolean} showExtraIcons - Indica si se deben mostrar íconos adicionales para herramientas de medición.
     * @param {string} color - Color del perímetro cuando se utiliza `sickPerimeter`.
     * @param {string} disease_name - Nombre de la enfermedad asociado a los puntos o perímetros mostrados.
     * @param {Array|null} polygons - Lista de polígonos a mostrar en el mapa.
     *                                Cada polígono debe contener las propiedades `rings` (coordenadas),
     *                                `color` (color del contorno) y `disease_name`.
     * @returns {void}
     */
    loadBaseMap(
      nameKml,
      showMeasurement = false,
      layersList = false,
      mapRef = null,
      points = null,
      zoom = null,
      sickPerimeter = null,
      showExtraIcons = true,
      color = '',
      disease_name = '',
      polygons = []
    ) {
      loadModules(importBaseMap, { css: true })
        .then(
          ([
            Map,
            MapView,
            Graphic,
            Point,
            PictureMarkerSymbol,
            KMLLayer,
            ScaleBar,
            Fullscreen,
            BasemapGallery,
            Expand,
            Home,
            Print,
            Measurement,
            Sketch,
            GraphicsLayer,
            LayerList,
            FeatureLayer,
            Color,
            intl,
          ]) => {
            intl.setLocale(i18n.locale.toLowerCase());
            const measurement = new Measurement();
            let layer;
            let view;
            let graphicsLayer;

            if (showMeasurement) {
              graphicsLayer = new GraphicsLayer({
                title: i18n.t('uti.mixinArcgisMap.graphicsLayer'),
              });
            }

            if (mapRef == null) {
              mapRef = this.$refs.map;
            }

            if (nameKml != null) {
              layer = [];

              if (Array.isArray(nameKml)) {
                nameKml.forEach((element) => {
                  layer.push(
                    new KMLLayer({
                      url: LINK_MAPS + element + '/Perimetro.kml',
                    })
                  );
                });
              } else {
                layer.push(
                  new KMLLayer({
                    url: LINK_MAPS + nameKml + '/Perimetro.kml',
                  })
                );
              }

              view = new Map({
                basemap: 'hybrid',
                layers: layer,
              });
            } else {
              if (showMeasurement) {
                view = new Map({
                  basemap: 'hybrid',
                  layers: [graphicsLayer],
                });
              } else {
                view = new Map({
                  basemap: 'hybrid',
                });
              }
            }

            if (points != null && Array.isArray(points)) {
              this.center = this.getCenterExtend(points);
            }

            this.map = new MapView({
              container: mapRef,
              map: view,
              zoom: zoom != null ? zoom : 14,
              center: [this.center.lng, this.center.lat],
            });

            if (layersList) {
              this.map.ui.add(
                new Expand({
                  view: this.map,
                  content: new LayerList({
                    view: this.map,
                  }),
                }),
                'top-right'
              );
            }

            if (showMeasurement) {
              this.map.ui.add(
                new Expand({
                  expandIconClass: 'esri-icon-sketch-rectangle',
                  view: this.map,
                  content: new Sketch({
                    layer: graphicsLayer,
                    view: this.map,
                    creationMode: 'update',
                  }),
                }),
                'top-right'
              );

              let activeView = this.map;
              if (showExtraIcons) {
                const distanceButton = document.getElementById('distance');
                const areaButton = document.getElementById('area');
                const clearButton = document.getElementById('clear');

                distanceButton.addEventListener('click', function () {
                  const type = activeView.type;
                  measurement.activeTool =
                    type.toUpperCase() === '2D' ? 'distance' : 'direct-line';
                  distanceButton.classList.add('active');
                  areaButton.classList.remove('active');
                });

                areaButton.addEventListener('click', function () {
                  measurement.activeTool = 'area';
                  distanceButton.classList.remove('active');
                  areaButton.classList.add('active');
                });

                clearButton.addEventListener('click', function () {
                  distanceButton.classList.remove('active');
                  areaButton.classList.remove('active');
                  measurement.clear();
                });

                measurement.view = activeView;
                this.map.ui.add(measurement, 'top-right');
              }
            }

            if (points != null && Array.isArray(points)) {
              // Crear una nueva capa de gráficos para los puntos
              let pointsLayer = new GraphicsLayer({
                title: i18n.t('uti.mixinArcgisMap.layer_points'),
              });

              points.forEach((element) => {
                let pointGraphic = new Graphic({
                  geometry: {
                    type: 'point',
                    longitude: element.lng,
                    latitude: element.lat,
                  },
                  symbol: {
                    type: 'simple-marker',
                    color: element.color ? element.color : [226, 119, 40],
                    outline: {
                      color: [255, 255, 255],
                      width: 1.3,
                    },
                  },
                  popupTemplate: {
                    title: `<b> ${
                      element.name ? element.name : disease_name
                    } </b>`,
                    style: {
                      width: '300px',
                      backgroundColor: '#D6EAF8',
                      border: '2px solid #707070',
                      borderRadius: '4px',
                      boxShadow: '1px 1px 2px gray',
                    },
                  },
                });

                pointsLayer.add(pointGraphic); // Agregar cada punto a la GraphicsLayer
              });

              // Agregar la capa de puntos al mapa (como una capa independiente)
              this.map.map.add(pointsLayer);

              if (polygons && polygons.length > 0) {
                // Crear una nueva capa de gráficos para los polígonos
                let polygonsLayer = new GraphicsLayer({
                  title: i18n.t('uti.mixinArcgisMap.layer_polygons'),
                });

                polygons.forEach((polygon) => {
                  let polygonGraphic = new Graphic({
                    geometry: {
                      type: 'polygon',
                      rings: polygon.rings,
                    },
                    symbol: {
                      type: 'simple-fill',
                      color: [255, 255, 255, 0], // Transparente
                      outline: {
                        color: polygon.color || '#FF0000',
                        width: 2,
                      },
                    },
                    popupTemplate: {
                      title: polygon.disease_name,
                      content: i18n.t('common_words.perimeter_case'),
                    },
                  });

                  polygonsLayer.add(polygonGraphic); // Agregar el polígono a la GraphicsLayer
                });

                // Agregar la capa de polígonos al mapa como una capa independiente
                this.map.map.add(polygonsLayer);
              }

              if (sickPerimeter != null) {
                const polygon = {
                  type: 'polygon',
                  rings: [],
                };

                sickPerimeter.forEach((coord) => {
                  let splited = coord.split(',');
                  polygon.rings.push(splited);
                });

                polygon.rings.push(sickPerimeter[0].split(','));
                const polylineGraphic = new Graphic({
                  geometry: polygon,
                });
                const renderer = {
                  type: 'simple',
                  symbol: {
                    color: [255, 255, 255, 0],
                    type: 'simple-fill',
                    outline: {
                      style: 'solid',
                      color:
                        color != (undefined || null) ? color : [226, 119, 40],
                      width: 3,
                    },
                  },
                };

                let feature = new FeatureLayer({
                  title: `${'perimetro'}`,
                  source: [polylineGraphic],
                  renderer: renderer,
                  fields: [
                    {
                      name: 'ObjectID',
                      alias: 'ObjectID',
                      type: 'oid',
                    },
                    {
                      name: 'place',
                      alias: 'Place',
                      type: 'string',
                    },
                  ],
                  objectIdField: 'ObjectID',
                  geometryType: 'polygon',
                });

                view.add(feature);
              }
            } else {
              this.map.graphics.add(
                new Graphic(
                  new Point(this.center.lng, this.center.lat),
                  new PictureMarkerSymbol(
                    '/static/img/iconos/location-pointer.svg',
                    30,
                    30
                  )
                )
              );
            }

            this.map.ui.add(
              new Fullscreen({
                view: this.map,
                element: mapRef,
              }),
              'top-left'
            );

            this.map.ui.add(
              new ScaleBar({
                view: this.map,
                unit: 'dual',
              }),
              'bottom-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new BasemapGallery({
                  view: this.map,
                }),
              }),
              'top-left'
            );

            this.map.ui.add(
              new Home({
                view: this.map,
              }),
              'top-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new Print({
                  view: this.map,
                  printServiceUrl:
                    'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
                  templateOptions: {
                    legendEnabled: false,
                  },
                }),
              }),
              'top-left'
            );

            this.removeLayerUntitled();
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },

    loadHeatMap(nameKml, heatMapData) {
      loadModules(importHeatMap, { css: true })
        .then(
          ([
            Map,
            MapView,
            FeatureLayer,
            KMLLayer,
            ScaleBar,
            Fullscreen,
            BasemapGallery,
            Expand,
            Home,
            Print,
            Legend,
            Measurement,
            Sketch,
            GraphicsLayer,
            LayerList,
            intl,
          ]) => {
            intl.setLocale(i18n.locale.toLowerCase());
            let layerHeatMap;
            let graphicsLayer = new GraphicsLayer({
              title: i18n.t('uti.mixinArcgisMap.graphicsLayer'),
            });
            const measurement = new Measurement();
            if (heatMapData != null) {
              layerHeatMap = new FeatureLayer(heatMapData);
            }

            let layer;
            let view;
            if (nameKml != null) {
              layer = new KMLLayer({
                url: LINK_MAPS + nameKml + '/Perimetro.kml',
              });

              view = new Map({
                basemap: 'hybrid',
                layers: [layer, layerHeatMap, graphicsLayer],
              });
            } else {
              if (heatMapData != null) {
                view = new Map({
                  basemap: 'hybrid',
                  layers: [layerHeatMap, graphicsLayer],
                });
              } else {
                view = new Map({
                  basemap: 'hybrid',
                  layers: [graphicsLayer],
                });
              }
            }

            this.map = new MapView({
              container: this.$refs.map,
              map: view,
              zoom: 14,
              center: [this.center.lng, this.center.lat],
            });

            let activeView = this.map;
            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new LayerList({
                  view: this.map,
                }),
              }),
              'top-right'
            );

            this.map.ui.add(
              new Expand({
                expandIconClass: 'esri-icon-sketch-rectangle',
                view: this.map,
                content: new Sketch({
                  layer: graphicsLayer,
                  view: this.map,
                  creationMode: 'update',
                }),
              }),
              'top-right'
            );

            const distanceButton = document.getElementById('distance');
            const areaButton = document.getElementById('area');
            const clearButton = document.getElementById('clear');

            distanceButton.addEventListener('click', function () {
              const type = activeView.type;
              measurement.activeTool =
                type.toUpperCase() === '2D' ? 'distance' : 'direct-line';
              distanceButton.classList.add('active');
              areaButton.classList.remove('active');
            });

            areaButton.addEventListener('click', function () {
              measurement.activeTool = 'area';
              distanceButton.classList.remove('active');
              areaButton.classList.add('active');
            });

            clearButton.addEventListener('click', function () {
              distanceButton.classList.remove('active');
              areaButton.classList.remove('active');
              measurement.clear();
            });

            measurement.view = activeView;
            this.map.ui.add(measurement, 'top-right');

            this.map.ui.add(
              new Fullscreen({
                view: this.map,
                element: this.$refs.map,
              }),
              'top-left'
            );

            this.map.ui.add(
              new ScaleBar({
                view: this.map,
                unit: 'dual',
              }),
              'bottom-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new BasemapGallery({
                  view: this.map,
                }),
              }),
              'top-left'
            );

            this.map.ui.add(
              new Home({
                view: this.map,
              }),
              'top-left'
            );

            let legend = new Expand({
              expandIconClass: 'esri-icon-polygon',
              view: this.map,
              content: new Legend({
                view: this.map,
                layerInfos: [
                  {
                    layer: layerHeatMap,
                  },
                ],
              }),
            });

            this.map.ui.add(legend, 'top-right');

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new Print({
                  view: this.map,
                  printServiceUrl:
                    'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
                  templateOptions: {
                    legendEnabled: false,
                  },
                }),
              }),
              'top-left'
            );

            this.removeLayerUntitled();
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },

    loadPointMap(nameKml, heatPointData, zoom = null, center = {}) {
      loadModules(
        [
          'esri/Map',
          'esri/views/MapView',
          'esri/layers/FeatureLayer',
          'esri/layers/KMLLayer',
          'esri/widgets/ScaleBar',
          'esri/widgets/Fullscreen',
          'esri/widgets/BasemapGallery',
          'esri/widgets/Expand',
          'esri/widgets/Home',
          'esri/widgets/Print',
          'esri/widgets/Measurement',
          'esri/widgets/Sketch',
          'esri/layers/GraphicsLayer',
          'esri/widgets/LayerList',
          'esri/intl',
        ],
        { css: true }
      )
        .then(
          ([
            Map,
            MapView,
            FeatureLayer,
            KMLLayer,
            ScaleBar,
            Fullscreen,
            BasemapGallery,
            Expand,
            Home,
            Print,
            Measurement,
            Sketch,
            GraphicsLayer,
            LayerList,
            intl,
          ]) => {
            intl.setLocale(i18n.locale.toLowerCase());
            let elThis = this;
            let layerHeatMap;
            let graphicsLayer = new GraphicsLayer({
              title: i18n.t('uti.mixinArcgisMap.graphicsLayer'),
            });
            const measurement = new Measurement();
            if (heatPointData != null) {
              const uniqueValueInfos = heatPointData.source.map((point) => {
                return {
                  value: point.attributes.Identificador,
                  type: 'simple',
                  symbol: {
                    type: 'simple-marker',
                    color: point.attributes.Color,
                    outline: { color: [255, 255, 255], width: 1.3 },
                  },
                };
              });

              const renderer = {
                type: 'unique-value',
                field: 'Identificador',
                uniqueValueInfos: uniqueValueInfos,
              };

              layerHeatMap = new FeatureLayer(heatPointData);
              layerHeatMap.renderer = renderer;
            }

            let layer;
            let view;
            if (nameKml != null) {
              layer = new KMLLayer({
                url: LINK_MAPS + nameKml + '/Perimetro.kml',
              });

              view = new Map({
                basemap: 'hybrid',
                layers: [layer, layerHeatMap, graphicsLayer],
              });
            } else {
              if (heatPointData != null) {
                view = new Map({
                  basemap: 'hybrid',
                  layers: [layerHeatMap, graphicsLayer],
                });
              } else {
                view = new Map({
                  basemap: 'hybrid',
                  layers: [graphicsLayer],
                });
              }
            }

            if (heatPointData != null && Array.isArray(heatPointData.points)) {
              this.center = center;
            }

            this.map = new MapView({
              container: this.$refs.map,
              map: view,
              zoom: zoom != null ? zoom : 14,
              center: [this.center.lng, this.center.lat],
            });

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new LayerList({
                  view: this.map,
                }),
              }),
              'top-right'
            );

            this.map.ui.add(
              new Expand({
                expandIconClass: 'esri-icon-sketch-rectangle',
                view: this.map,
                content: new Sketch({
                  layer: graphicsLayer,
                  view: this.map,
                  creationMode: 'update',
                }),
              }),
              'top-right'
            );

            let activeView = this.map;
            const distanceButton = document.getElementById('distance');
            const areaButton = document.getElementById('area');
            const clearButton = document.getElementById('clear');

            distanceButton.addEventListener('click', function () {
              const type = activeView.type;
              measurement.activeTool =
                type.toUpperCase() === '2D' ? 'distance' : 'direct-line';
              distanceButton.classList.add('active');
              areaButton.classList.remove('active');
            });

            areaButton.addEventListener('click', function () {
              measurement.activeTool = 'area';
              distanceButton.classList.remove('active');
              areaButton.classList.add('active');
            });

            clearButton.addEventListener('click', function () {
              distanceButton.classList.remove('active');
              areaButton.classList.remove('active');
              measurement.clear();
            });

            measurement.view = activeView;
            this.map.ui.add(measurement, 'top-right');

            let fullScreen = new Fullscreen({
              view: this.map,
              element: this.$refs.map,
            });

            this.map.ui.add(fullScreen, 'top-left');

            this.map.ui.add(
              new ScaleBar({
                view: this.map,
                unit: 'dual',
              }),
              'bottom-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new BasemapGallery({
                  view: this.map,
                }),
              }),
              'top-left'
            );

            this.map.ui.add(
              new Home({
                view: this.map,
              }),
              'top-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new Print({
                  view: this.map,
                  printServiceUrl:
                    'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
                  templateOptions: {
                    legendEnabled: false,
                  },
                }),
              }),
              'top-left'
            );

            if (heatPointData.mapHeight) {
              this.map.on('resize', function (event) {
                const { oldHeight } = event;
                const isFullScreen = sessionStorage.getItem('esri-fullscreen');

                if (
                  isFullScreen === 'true' &&
                  Number(oldHeight) != Number(heatPointData.mapHeight)
                ) {
                  elThis.loadMap();
                  sessionStorage.removeItem('esri-fullscreen');
                }

                if (isFullScreen === 'false') elThis.loadMap();
              });
            }

            this.map.popup.on('trigger-action', function (event) {
              if (event.action.id === 'measure-this') {
                if (fullScreen.viewModel.state === 'active') {
                  fullScreen.viewModel.exit();
                  elThis.showForecast();
                } else {
                  elThis.showForecast();
                }
              }
            });

            this.removeLayerUntitled();
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },

    loadMapRegistrationForm(
      go_center = true,
      centers = [],
      mapRef = null,
      points = null,
      zoom = null
    ) {
      loadModules(importMapRegistrationForm, { css: true })
        .then(
          ([
            Map,
            MapView,
            Graphic,
            Point,
            PictureMarkerSymbol,
            ScaleBar,
            Fullscreen,
            Home,
            Locate,
            Search,
            CoordinateConversion,
            SceneView,
            intl,
          ]) => {
            intl.setLocale(i18n.locale.toLowerCase());
            let view;
            view = new Map({
              basemap: 'hybrid',
              //ground: "world-elevation"
            });

            if (mapRef == null) {
              mapRef = this.$refs.map;
            }

            if (go_center) {
              this.map = new SceneView({
                container: mapRef,
                map: view,
                zoom: zoom != null ? zoom : 14,
                center: [this.center.lng, this.center.lat],
              });
            } else {
              this.center = this.getCenterExtend(centers);
              this.map = new SceneView({
                container: mapRef,
                map: view,
                zoom: zoom != null ? zoom : 14 - centers.length,
                center: [this.center.lng, this.center.lat],
              });
            }

            if (points != null && Array.isArray(points)) {
              points.forEach((element) => {
                this.map.graphics.add(
                  new Graphic({
                    geometry: {
                      type: 'point',
                      longitude: element.lng,
                      latitude: element.lat,
                    },
                    symbol: {
                      type: 'simple-marker',
                      color: [226, 119, 40],
                      outline: {
                        color: [255, 255, 255],
                        width: 1.3,
                      },
                    },
                  })
                );
              });
            } else {
              if (go_center) {
                this.map.graphics.add(
                  new Graphic(
                    new Point(this.center.lng, this.center.lat),
                    new PictureMarkerSymbol(
                      '/static/img/iconos/location-pointer.svg',
                      30,
                      30
                    )
                  )
                );
              }
            }

            let searchWidget = new Search({
              view: this.map,
            });
            this.map.ui.add(searchWidget, 'top-right');
            this.map.when(function (e) {
              searchWidget.on('search-complete', function (event) {
                let m = event.results[0].results[0].extent.center;
                let model = refs.formulario.__vue__.model;
                model.latitude = m.latitude;
                model.longitude = m.longitude;
                refs.formulario.__vue__.geoMap();
              });
            });

            /* let ccWidget = new CoordinateConversion({
               view: this.map
             });
             this.map.ui.add(ccWidget, "bottom-right");
             ccWidget.visibleElements = {
               settingsButton: false,
               inputButton: false,
               captureButton: false
             };
             ccWidget.multipleConversions = false;*/

            window.refs = this.$refs;
            this.map.on('click', function (event) {
              let m = event.mapPoint;
              let model = refs.formulario.__vue__.model;
              model.latitude = m.latitude;
              model.longitude = m.longitude;
              //model.altitude = m.z;
              refs.formulario.__vue__.geoMap();
            });

            let locateWidget = new Locate({
              view: this.map,
            });
            this.map.ui.add(locateWidget, 'top-left');
            this.map.when(function () {
              locateWidget.on('locate', function (locateEvent) {
                let m = locateEvent.position.coords;
                let model = refs.formulario.__vue__.model;
                model.latitude = m.latitude;
                model.longitude = m.longitude;
                refs.formulario.__vue__.geoMap();
              });
            });

            this.map.ui.add(
              new Fullscreen({
                view: this.map,
                element: mapRef,
              }),
              'top-left'
            );
            this.map.ui.add(
              new ScaleBar({
                view: this.map,
                unit: 'dual',
              }),
              'bottom-left'
            );
            this.map.ui.add(
              new Home({
                view: this.map,
              }),
              'top-left'
            );

            this.removeLayerUntitled();
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },

    loadMapMultipleC(
      namesFilesKml,
      showMeasurement = false,
      go_center = true,
      centers = [],
      mapRef = null,
      points = null,
      zoom = null
    ) {
      loadModules(importMapMultipleC, { css: true })
        .then(
          ([
            Map,
            MapView,
            Graphic,
            Point,
            PictureMarkerSymbol,
            KMLLayer,
            ScaleBar,
            Fullscreen,
            BasemapGallery,
            Expand,
            Home,
            Print,
            Measurement,
            Sketch,
            GraphicsLayer,
            LayerList,
            CoordinateConversion,
            intl,
          ]) => {
            intl.setLocale(i18n.locale.toLowerCase());
            const measurement = new Measurement();
            let layer = [];
            let view;
            if (showMeasurement) {
              var graphicsLayer = new GraphicsLayer({
                title: i18n.t('uti.mixinArcgisMap.graphicsLayer'),
              });
            }

            if (mapRef == null) {
              mapRef = this.$refs.map;
            }

            let visible = true;
            if (namesFilesKml.length > 0) {
              namesFilesKml.forEach((element) => {
                if (
                  element.includes('CableVia') == true ||
                  element.includes('Drenaje') == true
                ) {
                  visible = false;
                } else {
                  visible = true;
                }
                element = element.split('|');
                if (element[1]) {
                  layer.push(
                    new KMLLayer({
                      url: LINK_MAPS + element[0] + '.kml',
                      title: element[0].split('/')[1] + ' ' + element[1],
                      visible: visible,
                    })
                  );
                } else {
                  layer.push(
                    new KMLLayer({
                      url: LINK_MAPS + element[0] + '.kml',
                      visible: visible,
                    })
                  );
                }
              });

              if (showMeasurement) {
                layer.push(graphicsLayer);
              }

              view = new Map({
                basemap: 'hybrid',
                layers: layer,
              });
            } else {
              if (showMeasurement) {
                view = new Map({
                  basemap: 'hybrid',
                  layers: [graphicsLayer],
                });
              } else {
                view = new Map({
                  basemap: 'hybrid',
                });
              }
            }

            if (go_center) {
              this.map = new MapView({
                container: mapRef,
                map: view,
                zoom: zoom != null ? zoom : 14,
                center: [this.center.lng, this.center.lat],
              });
            } else {
              this.center = this.getCenterExtend(centers);
              this.map = new MapView({
                container: mapRef,
                map: view,
                zoom: zoom != null ? zoom : 14 - centers.length,
                center: [this.center.lng, this.center.lat],
              });
            }

            let lylist = new LayerList({
              view: this.map,
            });

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: lylist,
              }),
              'top-right'
            );

            /* const ccWidget = new CoordinateConversion({
               view: this.map
             });
     
             this.map.ui.add(ccWidget, "bottom-right");*/

            if (showMeasurement) {
              this.map.ui.add(
                new Expand({
                  expandIconClass: 'esri-icon-sketch-rectangle',
                  view: this.map,
                  content: new Sketch({
                    layer: graphicsLayer,
                    view: this.map,
                    creationMode: 'update',
                  }),
                }),
                'top-right'
              );

              const distanceButton = document.getElementById('distance');
              const areaButton = document.getElementById('area');
              const clearButton = document.getElementById('clear');
              let activeView = this.map;

              distanceButton.addEventListener('click', function () {
                const type = activeView.type;
                measurement.activeTool =
                  type.toUpperCase() === '2D' ? 'distance' : 'direct-line';
                distanceButton.classList.add('active');
                areaButton.classList.remove('active');
              });

              areaButton.addEventListener('click', function () {
                measurement.activeTool = 'area';
                distanceButton.classList.remove('active');
                areaButton.classList.add('active');
              });

              clearButton.addEventListener('click', function () {
                distanceButton.classList.remove('active');
                areaButton.classList.remove('active');
                measurement.clear();
              });

              measurement.view = activeView;
              this.map.ui.add(measurement, 'top-right');
            }

            if (points != null && Array.isArray(points)) {
              points.forEach((element) => {
                this.map.graphics.add(
                  new Graphic({
                    geometry: {
                      type: 'point',
                      longitude: element.lng,
                      latitude: element.lat,
                    },
                    symbol: {
                      type: 'simple-marker',
                      color: [226, 119, 40],
                      outline: {
                        color: [255, 255, 255],
                        width: 1.3,
                      },
                    },
                  })
                );
              });
            } else {
              if (go_center) {
                this.map.graphics.add(
                  new Graphic(
                    new Point(this.center.lng, this.center.lat),
                    new PictureMarkerSymbol(
                      '/static/img/iconos/location-pointer.svg',
                      30,
                      30
                    )
                  )
                );
              }
            }

            this.map.ui.add(
              new Fullscreen({
                view: this.map,
                element: mapRef,
              }),
              'top-left'
            );

            this.map.ui.add(
              new ScaleBar({
                view: this.map,
                unit: 'dual',
              }),
              'bottom-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new BasemapGallery({
                  view: this.map,
                }),
              }),
              'top-left'
            );

            this.map.ui.add(
              new Home({
                view: this.map,
              }),
              'top-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new Print({
                  view: this.map,
                  printServiceUrl:
                    'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
                  templateOptions: {
                    legendEnabled: false,
                  },
                }),
              }),
              'top-left'
            );

            const scope = this;
            this.map.on('click', function (event) {
              let m = event.mapPoint;
              scope.setGeoPosition(m, scope);
              scope.geoMap();
            });

            this.removeLayerUntitled();
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },

    loadMapProduction(
      go_center = true,
      centers = [],
      notAllowedKML,
      namesFilesKml,
      data = null,
      farm,
      showMeasurement = false,
      mapRef = null,
      points = null,
      zoom = null
    ) {
      loadModules(importMapProduction, { css: true })
        .then(
          ([
            Map,
            MapView,
            FeatureLayer,
            Graphic,
            Point,
            PictureMarkerSymbol,
            KMLLayer,
            ScaleBar,
            Fullscreen,
            BasemapGallery,
            Expand,
            Home,
            Print,
            Measurement,
            Sketch,
            GraphicsLayer,
            LayerList,
            Legend,
            intl,
          ]) => {
            intl.setLocale(i18n.locale.toLowerCase());
            let layerMap;
            let layer = [];
            let view;
            const measurement = new Measurement();
            if (mapRef == null) {
              mapRef = this.$refs.map;
            }

            if (showMeasurement) {
              var graphicsLayer = new GraphicsLayer({
                title: i18n.t('uti.mixinArcgisMap.graphicsLayer'),
              });
            }

            let visible = true;

            if (data != null && data.length > 0) {
              data.forEach((dato) => {
                layerMap = new FeatureLayer({ ...dato, listMode: 'hide' });
                layer.push(layerMap);
              });
            }

            if (namesFilesKml.length > 0) {
              namesFilesKml.forEach((element) => {
                let splited = element.split('/')[1];
                if (!notAllowedKML.includes(splited)) {
                  if (splited == 'CableVia' || splited == 'Drenaje') {
                    visible = false;
                  } else {
                    visible = true;
                  }
                  layer.push(
                    new KMLLayer({
                      url: LINK_MAPS + element + '.kml',
                      visible: visible,
                      listMode: 'hide-children',
                    })
                  );
                }
              });

              if (showMeasurement) {
                layer.push(graphicsLayer);
              }

              view = new Map({
                basemap: 'hybrid',
                layers: layer,
              });
            } else {
              if (showMeasurement) {
                layer.push(graphicsLayer);
              }

              if (showMeasurement) {
                view = new Map({
                  basemap: 'hybrid',
                  layers: layer,
                });
              } else {
                view = new Map({
                  basemap: 'hybrid',
                  layers: layer,
                });
              }
            }

            if (go_center) {
              this.map = new MapView({
                container: mapRef,
                map: view,
                zoom: zoom != null ? zoom : 14,
                center: [this.center.lng, this.center.lat],
              });
            } else {
              this.center = this.getCenterExtend(centers);
              this.map = new MapView({
                container: mapRef,
                map: view,
                zoom: zoom != null ? zoom : 14 - centers.length,
                center: [this.center.lng, this.center.lat],
              });
            }

            let featureLayer = view.layers.getItemAt(0);
            let leyenda2 = new Expand({
              view: this.map,
              content: new Legend({
                view: this.map,
                layerInfos: [
                  {
                    layer: featureLayer,
                    title: farm,
                  },
                ],
              }),
            });

            let leyenda = new Expand({
              view: this.map,
              content: new LayerList({
                view: this.map,
                listItemCreatedFunction: function (event) {
                  const item = event.item;
                  if (item.layer.type != 'group') {
                    // don't show legend twice
                    // item.panel = {
                    //   content: "legend",
                    //   open: false
                    // };
                  }
                },
              }),
            });

            this.map.ui.add(leyenda, 'top-right');
            this.map.ui.add(leyenda2, 'top-right');
            if (showMeasurement) {
              this.map.ui.add(
                new Expand({
                  expandIconClass: 'esri-icon-sketch-rectangle',
                  view: this.map,
                  content: new Sketch({
                    layer: graphicsLayer,
                    view: this.map,
                    creationMode: 'update',
                  }),
                }),
                'top-right'
              );

              const distanceButton = document.getElementById('distance');
              const areaButton = document.getElementById('area');
              const clearButton = document.getElementById('clear');
              let activeView = this.map;

              distanceButton.addEventListener('click', function () {
                const type = activeView.type;
                measurement.activeTool =
                  type.toUpperCase() === '2D' ? 'distance' : 'direct-line';
                distanceButton.classList.add('active');
                areaButton.classList.remove('active');
              });

              areaButton.addEventListener('click', function () {
                measurement.activeTool = 'area';
                distanceButton.classList.remove('active');
                areaButton.classList.add('active');
              });

              clearButton.addEventListener('click', function () {
                distanceButton.classList.remove('active');
                areaButton.classList.remove('active');
                measurement.clear();
              });

              measurement.view = activeView;
              this.map.ui.add(measurement, 'top-right');
            }

            if (points != null && Array.isArray(points)) {
              points.forEach((element) => {
                this.map.graphics.add(
                  new Graphic({
                    geometry: {
                      type: 'point',
                      longitude: element.lng,
                      latitude: element.lat,
                    },
                    symbol: {
                      type: 'simple-marker',
                      color: [226, 119, 40],
                      outline: {
                        color: [255, 255, 255],
                        width: 1.3,
                      },
                    },
                  })
                );
              });
            } else {
              this.map.graphics.add(
                new Graphic(
                  new Point(this.center.lng, this.center.lat),
                  new PictureMarkerSymbol(
                    '/static/img/iconos/location-pointer.svg',
                    30,
                    30
                  )
                )
              );
            }

            this.map.ui.add(
              new Fullscreen({
                view: this.map,
                element: mapRef,
              }),
              'top-left'
            );

            this.map.ui.add(
              new ScaleBar({
                view: this.map,
                unit: 'dual',
              }),
              'bottom-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new BasemapGallery({
                  view: this.map,
                }),
              }),
              'top-left'
            );

            this.map.ui.add(
              new Home({
                view: this.map,
              }),
              'top-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new Print({
                  view: this.map,
                  printServiceUrl:
                    'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
                  templateOptions: {
                    legendEnabled: false,
                  },
                }),
              }),
              'top-left'
            );

            this.removeLayerUntitled();
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },

    loadMapClima(
      go_center = true,
      centers,
      notAllowedKML,
      namesFilesKml,
      data = null,
      farm,
      showMeasurement = true,
      mapRef = null,
      points = null,
      zoom = null
    ) {
      loadModules(importMapProduction, { css: true })
        .then(
          ([
            Map,
            MapView,
            FeatureLayer,
            Graphic,
            Point,
            PictureMarkerSymbol,
            KMLLayer,
            ScaleBar,
            Fullscreen,
            BasemapGallery,
            Expand,
            Home,
            Print,
            Measurement,
            Sketch,
            GraphicsLayer,
            LayerList,
            Legend,
            intl,
          ]) => {
            intl.setLocale(i18n.locale.toLowerCase());
            let layerMap;
            let layer = [];
            let view;
            const measurement = new Measurement();
            if (mapRef == null) {
              mapRef = this.$refs.map;
            }

            if (showMeasurement) {
              var graphicsLayer = new GraphicsLayer({
                title: i18n.t('uti.mixinArcgisMap.graphicsLayer'),
              });
            }

            let visible = true;

            if (data != null && data.length > 0) {
              data.forEach((dato) => {
                layerMap = new FeatureLayer({ ...dato, listMode: 'hide' });
                layer.push(layerMap);
              });
            }

            if (namesFilesKml.length > 0) {
              namesFilesKml.forEach((element) => {
                let splited = element.split('/')[1].split('|')[0];
                if (!notAllowedKML.includes(splited)) {
                  if (splited == 'CableVia' || splited == 'Drenaje') {
                    visible = false;
                  } else {
                    visible = true;
                  }
                  layer.push(
                    new KMLLayer({
                      url: LINK_MAPS + element.split('|')[0] + '.kml',
                      visible: visible,
                      title:
                        element.split('/')[1].split('|')[0] +
                        ' ' +
                        element.split('/')[1].split('|')[1],
                      listMode: 'hide-children',
                    })
                  );
                }
              });

              if (showMeasurement) {
                layer.push(graphicsLayer);
              }

              view = new Map({
                basemap: 'hybrid',
                layers: layer,
              });
            } else {
              if (showMeasurement) {
                layer.push(graphicsLayer);
              }

              if (showMeasurement) {
                view = new Map({
                  basemap: 'hybrid',
                  layers: layer,
                });
              } else {
                view = new Map({
                  basemap: 'hybrid',
                  layers: layer,
                });
              }
            }

            if (go_center) {
              this.map = new MapView({
                container: mapRef,
                map: view,
                zoom: zoom != null ? zoom : 14,
                center: [this.center.lng, this.center.lat],
              });
            } else {
              this.center = this.getCenterExtend(centers);
              this.map = new MapView({
                container: mapRef,
                map: view,
                zoom: zoom != null ? zoom : 14 - centers.length,
                center: [this.center.lng, this.center.lat],
              });
            }

            let featureLayer = view.layers.getItemAt(0);
            let leyenda2 = new Expand({
              view: this.map,
              content: new Legend({
                view: this.map,
                layerInfos: [
                  {
                    layer: featureLayer,
                    title: farm,
                  },
                ],
              }),
            });

            let leyenda = new Expand({
              view: this.map,
              content: new LayerList({
                view: this.map,
                listItemCreatedFunction: function (event) {
                  const item = event.item;
                  if (item.layer.type != 'group') {
                    // don't show legend twice
                    // item.panel = {
                    //   content: "legend",
                    //   open: false
                    // };
                  }
                },
              }),
            });

            this.map.ui.add(leyenda, 'top-right');
            this.map.ui.add(leyenda2, 'top-right');
            if (showMeasurement) {
              this.map.ui.add(
                new Expand({
                  expandIconClass: 'esri-icon-sketch-rectangle',
                  view: this.map,
                  content: new Sketch({
                    layer: graphicsLayer,
                    view: this.map,
                    creationMode: 'update',
                  }),
                }),
                'top-right'
              );

              const distanceButton = document.getElementById('distance');
              const areaButton = document.getElementById('area');
              const clearButton = document.getElementById('clear');
              let activeView = this.map;

              distanceButton.addEventListener('click', function () {
                const type = activeView.type;
                measurement.activeTool =
                  type.toUpperCase() === '2D' ? 'distance' : 'direct-line';
                distanceButton.classList.add('active');
                areaButton.classList.remove('active');
              });

              areaButton.addEventListener('click', function () {
                measurement.activeTool = 'area';
                distanceButton.classList.remove('active');
                areaButton.classList.add('active');
              });

              clearButton.addEventListener('click', function () {
                distanceButton.classList.remove('active');
                areaButton.classList.remove('active');
                measurement.clear();
              });

              measurement.view = activeView;
              this.map.ui.add(measurement, 'top-right');
            }

            if (points != null && Array.isArray(points)) {
              points.forEach((element) => {
                this.map.graphics.add(
                  new Graphic({
                    geometry: {
                      type: 'point',
                      longitude: element.lng,
                      latitude: element.lat,
                    },
                    symbol: {
                      type: 'simple-marker',
                      color: [226, 119, 40],
                      outline: {
                        color: [255, 255, 255],
                        width: 1.3,
                      },
                    },
                  })
                );
              });
            } else {
              this.map.graphics.add(
                new Graphic(
                  new Point(this.center.lng, this.center.lat),
                  new PictureMarkerSymbol(
                    '/static/img/iconos/location-pointer.svg',
                    30,
                    30
                  )
                )
              );
            }

            this.map.ui.add(
              new Fullscreen({
                view: this.map,
                element: mapRef,
              }),
              'top-left'
            );

            this.map.ui.add(
              new ScaleBar({
                view: this.map,
                unit: 'dual',
              }),
              'bottom-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new BasemapGallery({
                  view: this.map,
                }),
              }),
              'top-left'
            );

            this.map.ui.add(
              new Home({
                view: this.map,
              }),
              'top-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new Print({
                  view: this.map,
                  printServiceUrl:
                    'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
                  templateOptions: {
                    legendEnabled: false,
                  },
                }),
              }),
              'top-left'
            );

            this.removeLayerUntitled();
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },

    loadMapMuestras(
      go_center = true,
      centers,
      notAllowedKML,
      namesFilesKml,
      data = null,
      farm,
      showMeasurement = true,
      mapRef = null,
      points = null,
      zoom = null
    ) {
      loadModules(importMapProduction, { css: true })
        .then(
          ([
            Map,
            MapView,
            FeatureLayer,
            Graphic,
            Point,
            PictureMarkerSymbol,
            KMLLayer,
            ScaleBar,
            Fullscreen,
            BasemapGallery,
            Expand,
            Home,
            Print,
            Measurement,
            Sketch,
            GraphicsLayer,
            LayerList,
            Legend,
            intl,
          ]) => {
            intl.setLocale(i18n.locale.toLowerCase());
            let layerMap;
            let layer = [];
            let view;
            const measurement = new Measurement();
            if (mapRef == null) {
              mapRef = this.$refs.map;
            }

            if (showMeasurement) {
              var graphicsLayer = new GraphicsLayer({
                title: i18n.t('uti.mixinArcgisMap.graphicsLayer'),
              });
            }

            let visible = true;

            if (data != null && data.length > 0) {
              data.forEach((dato) => {
                layerMap = new FeatureLayer({ ...dato, listMode: 'hide' });
                layer.push(layerMap);
              });
            }

            if (namesFilesKml.length > 0) {
              namesFilesKml.forEach((element) => {
                let splited = element.split('/')[1];
                if (!notAllowedKML.includes(splited)) {
                  if (splited == 'CableVia' || splited == 'Drenaje') {
                    visible = false;
                  } else {
                    visible = true;
                  }
                  layer.push(
                    new KMLLayer({
                      url: LINK_MAPS + element + '.kml',
                      visible: visible,
                      listMode: 'hide-children',
                    })
                  );
                }
              });

              if (showMeasurement) {
                layer.push(graphicsLayer);
              }

              view = new Map({
                basemap: 'hybrid',
                layers: layer,
              });
            } else {
              if (showMeasurement) {
                layer.push(graphicsLayer);
              }

              if (showMeasurement) {
                view = new Map({
                  basemap: 'hybrid',
                  layers: layer,
                });
              } else {
                view = new Map({
                  basemap: 'hybrid',
                  layers: layer,
                });
              }
            }

            if (go_center) {
              this.map = new MapView({
                container: mapRef,
                map: view,
                zoom: zoom != null ? zoom : 14,
                center: [this.center.lng, this.center.lat],
              });
            } else {
              this.center = this.getCenterExtend(centers);
              this.map = new MapView({
                container: mapRef,
                map: view,
                zoom: zoom != null ? zoom : 14 - centers.length,
                center: [this.center.lng, this.center.lat],
              });
            }

            let featureLayer = view.layers.getItemAt(0);

            let leyenda2 = new Expand({
              view: this.map,
              content: new Legend({
                view: this.map,
                layerInfos: [
                  {
                    layer: featureLayer,
                    title: farm,
                  },
                ],
              }),
            });

            let leyenda = new Expand({
              view: this.map,
              content: new LayerList({
                view: this.map,
                listItemCreatedFunction: function (event) {
                  const item = event.item;
                  if (item.layer.type != 'group') {
                    // don't show legend twice
                    // item.panel = {
                    //   content: "legend",
                    //   open: false
                    // };
                  }
                },
              }),
            });

            this.map.ui.add(leyenda, 'top-right');
            this.map.ui.add(leyenda2, 'top-right');
            if (showMeasurement) {
              this.map.ui.add(
                new Expand({
                  expandIconClass: 'esri-icon-sketch-rectangle',
                  view: this.map,
                  content: new Sketch({
                    layer: graphicsLayer,
                    view: this.map,
                    creationMode: 'update',
                  }),
                }),
                'top-right'
              );

              const distanceButton = document.getElementById('distance');
              const areaButton = document.getElementById('area');
              const clearButton = document.getElementById('clear');
              let activeView = this.map;

              distanceButton.addEventListener('click', function () {
                const type = activeView.type;
                measurement.activeTool =
                  type.toUpperCase() === '2D' ? 'distance' : 'direct-line';
                distanceButton.classList.add('active');
                areaButton.classList.remove('active');
              });

              areaButton.addEventListener('click', function () {
                measurement.activeTool = 'area';
                distanceButton.classList.remove('active');
                areaButton.classList.add('active');
              });

              clearButton.addEventListener('click', function () {
                distanceButton.classList.remove('active');
                areaButton.classList.remove('active');
                measurement.clear();
              });

              measurement.view = activeView;
              this.map.ui.add(measurement, 'top-right');
            }

            if (points != null && Array.isArray(points)) {
              points.forEach((element) => {
                this.map.graphics.add(
                  new Graphic({
                    geometry: {
                      type: 'point',
                      longitude: element.lng,
                      latitude: element.lat,
                    },
                    symbol: {
                      type: 'simple-marker',
                      color: [226, 119, 40],
                      outline: {
                        color: [255, 255, 255],
                        width: 1.3,
                      },
                    },
                  })
                );
              });
            } else {
              this.map.graphics.add(
                new Graphic(
                  new Point(this.center.lng, this.center.lat),
                  new PictureMarkerSymbol(
                    '/static/img/iconos/location-pointer.svg',
                    30,
                    30
                  )
                )
              );
            }

            this.map.ui.add(
              new Fullscreen({
                view: this.map,
                element: mapRef,
              }),
              'top-left'
            );

            this.map.ui.add(
              new ScaleBar({
                view: this.map,
                unit: 'dual',
              }),
              'bottom-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new BasemapGallery({
                  view: this.map,
                }),
              }),
              'top-left'
            );

            this.map.ui.add(
              new Home({
                view: this.map,
              }),
              'top-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new Print({
                  view: this.map,
                  printServiceUrl:
                    'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
                  templateOptions: {
                    legendEnabled: false,
                  },
                }),
              }),
              'top-left'
            );

            this.removeLayerUntitled();
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },

    setGeoPosition(m, scope) {
      for (const key in scope.$refs) {
        try {
          if (scope.$refs.hasOwnProperty(key)) {
            if (key == 'lat') scope.model.latitude = m.latitude;
            if (key == 'long') scope.model.longitude = m.longitude;
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    removeLayerUntitled() {
      setTimeout(() => {
        for (
          let index = 0;
          index <
          document.getElementsByClassName('esri-layer-list__item-title').length;
          index++
        ) {
          const element = document.getElementsByClassName(
            'esri-layer-list__item-title'
          )[index];
          if (
            element.getAttribute('aria-label') == 'Capa de gráficos' ||
            element.getAttribute('aria-label') == 'Untitled layer'
          ) {
            element.parentElement.parentElement.parentElement.remove();
          }
        }
      }, 500);
    },

    getCenterExtend(pts, calculate = true) {
      let extend = { lat: 0, lng: 0 };
      if (!calculate) {
        var lats = [];
        var lngs = [];
      }

      pts.map((point) => {
        if (calculate) {
          extend.lat += point.lat * 1;
          extend.lng += point.lng * 1;
        } else {
          lats.push(point.lat);
          lngs.push(point.lng);
        }
      });

      if (calculate) {
        extend.lat /= pts.length;
        extend.lng /= pts.length;

        return extend;
      } else {
        extend.lat = Math.max(...lats);
        extend.lng = Math.max(...lngs);

        return extend;
      }
    },

    /**
     * Método genérico para graficar una ruta a partir de una lista de puntos.
     * El primer punto se pinta en verde y el último en rojo.
     *
     * @param {Array} routePoints - Array de puntos con estructura:
     * [
     *   {
     *     latitude: "11.21377373",
     *     longitude: "-74.17609225",
     *     altitude: "28.28839111328125",
     *     full_date: "2026-02-22 08:35:55"
     *   }
     * ]
     * @param {HTMLElement|null} mapRef - Referencia al contenedor del mapa.
     * @param {string|null} basemap - Mapa base, por defecto 'hybrid'.
     * @param {number|null} zoom - Zoom inicial opcional.
     * @param {boolean} layersList - Mostrar lista de capas.
     * @returns {void}
     */
    routeMapBase(
      routePoints = [],
      mapRef = null,
      basemap = 'hybrid',
      zoom = null,
      layersList = false
    ) {
      if (!Array.isArray(routePoints) || routePoints.length === 0) {
        console.error('routeMapBase: se esperaba un arreglo de puntos válido');
        return;
      }

      if (mapRef == null) {
        mapRef =
          this.$refs.routeMap || this.$refs.multipleMap || this.$refs.map;
      }

      if (!mapRef) {
        console.error('routeMapBase: no se encontró un contenedor válido');
        return;
      }

      loadModules(
        [
          'esri/Map',
          'esri/views/MapView',
          'esri/Graphic',
          'esri/layers/GraphicsLayer',
          'esri/widgets/Expand',
          'esri/widgets/Fullscreen',
          'esri/widgets/ScaleBar',
          'esri/widgets/Home',
          'esri/widgets/LayerList',
          'esri/widgets/BasemapGallery',
          'esri/intl',
        ],
        { css: true }
      )
        .then(
          ([
            Map,
            MapView,
            Graphic,
            GraphicsLayer,
            Expand,
            Fullscreen,
            ScaleBar,
            Home,
            LayerList,
            BasemapGallery,
            intl,
          ]) => {
            intl.setLocale(i18n.locale.toLowerCase());
            // destruir mapa anterior si existe
            if (this.map) {
              this.map.destroy();
              this.map = null;
            }

            const validPoints = routePoints
              .map((point) => ({
                lat: parseFloat(point.latitude),
                lng: parseFloat(point.longitude),
                full_date: point.full_date || '',
              }))
              .filter((point) => !isNaN(point.lat) && !isNaN(point.lng));

            if (!validPoints.length) {
              console.error('routeMapBase: no hay coordenadas válidas');
              return;
            }

            const center = this.getCenterExtend(validPoints);

            const routeLayer = new GraphicsLayer({
              title: i18n.t('common_words.route_path'),
            });

            const pointsLayer = new GraphicsLayer({
              title: i18n.t('common_words.start_end'),
            });

            //LINEA DEL RECORRIDO
            const path = validPoints.map((point) => [point.lng, point.lat]);

            if (path.length >= 2) {
              const lineGraphic = new Graphic({
                geometry: {
                  type: 'polyline',
                  paths: [path],
                },
                symbol: {
                  type: 'simple-line',
                  color: '#E27728',
                  width: 3,
                },
              });

              routeLayer.add(lineGraphic);
            }

            //INICIO Y FIN
            const firstPoint = validPoints[0];
            const lastPoint = validPoints[validPoints.length - 1];

            //Inicio
            const startGraphic = new Graphic({
              geometry: {
                type: 'point',
                longitude: firstPoint.lng,
                latitude: firstPoint.lat,
              },
              symbol: {
                type: 'simple-marker',
                color: '#00B140',
                size: 10,
                outline: {
                  color: [255, 255, 255],
                  width: 2,
                },
              },
              attributes: {
                full_date: firstPoint.full_date,
                type: 'Inicio',
              },
              popupTemplate: {
                title: i18n.t('common_words.route_start'),
                content: `<b>${i18n.t('common_words.date')}:</b> {full_date}`,
              },
            });

            // Fin
            const endGraphic = new Graphic({
              geometry: {
                type: 'point',
                longitude: lastPoint.lng,
                latitude: lastPoint.lat,
              },
              symbol: {
                type: 'simple-marker',
                color: '#FF0000',
                size: 10,
                outline: {
                  color: [255, 255, 255],
                  width: 2,
                },
              },
              attributes: {
                full_date: lastPoint.full_date,
                type: 'Fin',
              },
              popupTemplate: {
                title: i18n.t('common_words.route_end'),
                content: `<b>${i18n.t('common_words.date')}:</b> {full_date}`,
              },
            });

            pointsLayer.add(startGraphic);
            pointsLayer.add(endGraphic);

            //MAPA
            const map = new Map({
              basemap: basemap || 'hybrid',
              layers: [routeLayer, pointsLayer],
            });

            this.map = new MapView({
              container: mapRef,
              map: map,
              zoom: zoom != null ? zoom : 15,
              center: [center.lng, center.lat],
            });

            //UI
            if (layersList) {
              this.map.ui.add(
                new Expand({
                  view: this.map,
                  content: new LayerList({
                    view: this.map,
                  }),
                }),
                'top-right'
              );
            }

            this.map.ui.add(
              new Fullscreen({
                view: this.map,
                element: mapRef,
              }),
              'top-left'
            );

            this.map.ui.add(
              new ScaleBar({
                view: this.map,
                unit: 'dual',
              }),
              'bottom-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new BasemapGallery({
                  view: this.map,
                }),
              }),
              'top-left'
            );

            this.map.ui.add(
              new Home({
                view: this.map,
              }),
              'top-left'
            );

            this.removeLayerUntitled();
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },

    /**
     * Método para generar un mapa con capas de puntos y lineas para graficar el tracking
     * de auditorias.
     * Dibuja perimetro, puntos de lugar y recorrido como capas independientes.
     */
    loadAuditReportMap({
      routePoints = [],
      placePoints = [],
      nameKml = null,
      mapRef = null,
      basemap = 'hybrid',
      zoom = null,
      layersList = true,
      showMeasurement = true,
    } = {}) {
      if (mapRef == null) {
        mapRef =
          this.$refs.routeMap || this.$refs.multipleMap || this.$refs.map;
      }

      if (!mapRef) {
        console.error('loadAuditReportMap: no se encontro un contenedor valido');
        return;
      }

      loadModules(
        [
          'esri/Map',
          'esri/views/MapView',
          'esri/Graphic',
          'esri/layers/GraphicsLayer',
          'esri/layers/KMLLayer',
          'esri/widgets/Expand',
          'esri/widgets/Fullscreen',
          'esri/widgets/ScaleBar',
          'esri/widgets/Home',
          'esri/widgets/LayerList',
          'esri/widgets/BasemapGallery',
          'esri/widgets/Measurement',
          'esri/widgets/Sketch',
          'esri/intl',
        ],
        { css: true }
      )
        .then(
          ([
            Map,
            MapView,
            Graphic,
            GraphicsLayer,
            KMLLayer,
            Expand,
            Fullscreen,
            ScaleBar,
            Home,
            LayerList,
            BasemapGallery,
            Measurement,
            Sketch,
            intl,
          ]) => {
            intl.setLocale(i18n.locale.toLowerCase());

            if (this.map) {
              this.map.destroy();
              this.map = null;
            }

            const validRoutePoints = Array.isArray(routePoints)
              ? routePoints
                  .map((point) => ({
                    lat: parseFloat(point.latitude),
                    lng: parseFloat(point.longitude),
                    full_date: point.full_date || '',
                  }))
                  .filter((point) => !isNaN(point.lat) && !isNaN(point.lng))
              : [];

            const validPlacePoints = Array.isArray(placePoints)
              ? placePoints
                  .map((point) => ({
                    lat: parseFloat(
                      point.lat != null ? point.lat : point.latitude
                    ),
                    lng: parseFloat(
                      point.lng != null ? point.lng : point.longitude
                    ),
                    color: point.color || [0, 0, 255],
                    farm_name: point.farm_name || '',
                    username: point.username || '',
                    name: point.name || '',
                    full_date: point.full_date || '',
                  }))
                  .filter((point) => !isNaN(point.lat) && !isNaN(point.lng))
              : [];

            const layers = [];

            if (nameKml != null) {
              const kmlNames = Array.isArray(nameKml) ? nameKml : [nameKml];
              kmlNames.forEach((element) => {
                layers.push(
                  new KMLLayer({
                    title: i18n.t('common_words.place'),
                    url: LINK_MAPS + element + '/Perimetro.kml',
                  })
                );
              });
            }

            let measurementLayer = null;
            if (showMeasurement) {
              measurementLayer = new GraphicsLayer({
                title: i18n.t('uti.mixinArcgisMap.graphicsLayer'),
              });
              layers.push(measurementLayer);
            }

            const routeLayer = new GraphicsLayer({
              title: i18n.t('common_words.route_path'),
            });

            const startEndLayer = new GraphicsLayer({
              title: i18n.t('common_words.start_end'),
            });

            const placesLayer = new GraphicsLayer({
              title: i18n.t('uti.mixinArcgisMap.layer_points'),
            });

            if (validRoutePoints.length > 0) {
              const path = validRoutePoints.map((point) => [
                point.lng,
                point.lat,
              ]);

              if (path.length >= 2) {
                routeLayer.add(
                  new Graphic({
                    geometry: {
                      type: 'polyline',
                      paths: [path],
                    },
                    symbol: {
                      type: 'simple-line',
                      color: '#E27728',
                      width: 3,
                    },
                  })
                );
              }

              const firstPoint = validRoutePoints[0];
              const lastPoint = validRoutePoints[validRoutePoints.length - 1];

              startEndLayer.add(
                new Graphic({
                  geometry: {
                    type: 'point',
                    longitude: firstPoint.lng,
                    latitude: firstPoint.lat,
                  },
                  symbol: {
                    type: 'simple-marker',
                    color: '#00B140',
                    size: 12,
                    outline: {
                      color: [255, 255, 255],
                      width: 2,
                    },
                  },
                  attributes: {
                    full_date: firstPoint.full_date,
                  },
                  popupTemplate: {
                    title: i18n.t('common_words.route_start'),
                    content: `<b>${i18n.t(
                      'common_words.date'
                    )}:</b> {full_date}`,
                  },
                })
              );

              startEndLayer.add(
                new Graphic({
                  geometry: {
                    type: 'point',
                    longitude: lastPoint.lng,
                    latitude: lastPoint.lat,
                  },
                  symbol: {
                    type: 'simple-marker',
                    color: '#FF0000',
                    size: 12,
                    outline: {
                      color: [255, 255, 255],
                      width: 2,
                    },
                  },
                  attributes: {
                    full_date: lastPoint.full_date,
                  },
                  popupTemplate: {
                    title: i18n.t('common_words.route_end'),
                    content: `<b>${i18n.t(
                      'common_words.date'
                    )}:</b> {full_date}`,
                  },
                })
              );
            }

            validPlacePoints.forEach((point) => {
              placesLayer.add(
                new Graphic({
                  geometry: {
                    type: 'point',
                    longitude: point.lng,
                    latitude: point.lat,
                  },
                  symbol: {
                    type: 'simple-marker',
                    color: point.color,
                    size: 8,
                    outline: {
                      color: [255, 255, 255],
                      width: 1,
                    },
                  },
                  attributes: {
                    name: point.name,
                    farm_name: point.farm_name,
                    username: point.username,
                    full_date: point.full_date,
                  },
                  popupTemplate: {
                    title: `<b>{name}</b>`,
                    content: `
                      <b>${i18n.t('common_words.farm')}:</b> {farm_name}<br>
                      <b>${i18n.t('common_words.user')}:</b> {username}<br>
                      <b>${i18n.t('common_words.save_date')}:</b> {full_date}
                    `,
                  },
                })
              );
            });

            if (routeLayer.graphics.length > 0) layers.push(routeLayer);
            if (placesLayer.graphics.length > 0) layers.push(placesLayer);
            if (startEndLayer.graphics.length > 0) layers.push(startEndLayer);

            const map = new Map({
              basemap: basemap || 'hybrid',
              layers,
            });

            if (startEndLayer.graphics.length > 0) {
              map.reorder(startEndLayer, map.layers.length - 1);
            }

            const centerPoints = validRoutePoints.concat(validPlacePoints);
            const center =
              centerPoints.length > 0
                ? this.getCenterExtend(centerPoints)
                : this.center;

            this.map = new MapView({
              container: mapRef,
              map,
              zoom: zoom != null ? zoom : 15,
              center: [center.lng, center.lat],
            });

            if (layersList) {
              this.map.ui.add(
                new Expand({
                  view: this.map,
                  content: new LayerList({
                    view: this.map,
                  }),
                }),
                'top-right'
              );
            }

            if (showMeasurement && measurementLayer) {
              this.map.ui.add(
                new Expand({
                  expandIconClass: 'esri-icon-sketch-rectangle',
                  view: this.map,
                  content: new Sketch({
                    layer: measurementLayer,
                    view: this.map,
                    creationMode: 'update',
                  }),
                }),
                'top-right'
              );

              const measurement = new Measurement();
              const distanceButton = document.getElementById('distance');
              const areaButton = document.getElementById('area');
              const clearButton = document.getElementById('clear');

              if (distanceButton && areaButton && clearButton) {
                const activeView = this.map;
                distanceButton.addEventListener('click', function () {
                  const type = activeView.type;
                  measurement.activeTool =
                    type.toUpperCase() === '2D' ? 'distance' : 'direct-line';
                  distanceButton.classList.add('active');
                  areaButton.classList.remove('active');
                });

                areaButton.addEventListener('click', function () {
                  measurement.activeTool = 'area';
                  distanceButton.classList.remove('active');
                  areaButton.classList.add('active');
                });

                clearButton.addEventListener('click', function () {
                  distanceButton.classList.remove('active');
                  areaButton.classList.remove('active');
                  measurement.clear();
                });

                measurement.view = activeView;
                this.map.ui.add(measurement, 'top-right');
              }
            }

            this.map.ui.add(
              new Fullscreen({
                view: this.map,
                element: mapRef,
              }),
              'top-left'
            );

            this.map.ui.add(
              new ScaleBar({
                view: this.map,
                unit: 'dual',
              }),
              'bottom-left'
            );

            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new BasemapGallery({
                  view: this.map,
                }),
              }),
              'top-left'
            );

            this.map.ui.add(
              new Home({
                view: this.map,
              }),
              'top-left'
            );

            this.removeLayerUntitled();
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },

    /**
     * Método para generar un mapa con capas de puntos y lineas para graficar el tracking
     * de múltiples actividades.
     * @param detailsArray Array de registros con estructura { detail_date, activity: { id, name, code }, geo_data: [...] }
     * @param mapRef HTMLElement contenedor para MapView (puede ser null)
     * @param basemap string con estilo de mapa base (puede ser null)
     * @param layerConfig objeto con opciones { defaultColor, defaultSize }
     * @param options objeto que define como graficara el mapa de lineas y puntos { pointsField: 'geo_data', lineField: 'geo_data_line',sortByHour: true, deviceType: 'mobile' }
     */
    loadSmartTrackMap(detailsArray, mapRef, basemap, layerConfig, options) {
      // Si mapRef sigue undefined, abortamos
      if (!mapRef || !(mapRef instanceof HTMLElement)) {
        console.error('loadSmartTrackMap: mapRef inválido', mapRef);
        return;
      }

      // Si no hay detalles, abortamos
      if (!Array.isArray(detailsArray)) {
        console.error(
          'loadSmartTrackMap: se esperaba un Array de detalles',
          detailsArray
        );
        return;
      }

      // Default basemap
      if (!basemap) basemap = 'hybrid';

      // Default layerConfig
      if (!layerConfig) layerConfig = {};

      var defaultColor = layerConfig.defaultColor;
      if (!defaultColor) defaultColor = [0, 0, 255];

      var defaultSize = layerConfig.defaultSize;
      if (!defaultSize) defaultSize = 8;

      var MOBILE_COLORS = {
        ptsBlue: [0, 0, 255], // azul
        startGreen: [0, 200, 0], // verde
        endRed: [255, 0, 0], // rojo
        lineOrange: [255, 165, 0], // naranja
      };

      options = options || {};
      var pointsField = options.pointsField || 'geo_data'; // puntos
      var lineField = options.lineField || pointsField; // línea (por defecto igual a puntos)
      var hourField = options.hourField || 'hour';
      var sortByHour = !!options.sortByHour; // opcional
      var deviceType = options.deviceType || null;
      var isMobile = deviceType === 'mobile';

      // Cargar módulos ArcGIS
      loadModules(
        [
          'esri/Map',
          'esri/views/MapView',
          'esri/Graphic',
          'esri/layers/GraphicsLayer',
          'esri/widgets/Expand',
          'esri/widgets/Fullscreen',
          'esri/widgets/ScaleBar',
          'esri/widgets/Home',
          'esri/widgets/LayerList',
          'esri/widgets/BasemapGallery',
        ],
        { css: true }
      )
        .then(
          function (modules) {
            var EsriMap = modules[0];
            var MapView = modules[1];
            var Graphic = modules[2];
            var GraphicsLayer = modules[3];

            var Expand = modules[4];
            var Fullscreen = modules[5];
            var ScaleBar = modules[6];
            var Home = modules[7];
            var LayerList = modules[8];
            var BasemapGallery = modules[9];

            // 1) Agrupar registros en "activitiesMap", generando un key único si hay duplicados
            var activitiesMap = new Map();

            detailsArray.forEach(function (record, idx) {
              var baseId = record.activity && record.activity.id;
              var name =
                (record.activity && record.activity.name) || 'Actividad';

              if (baseId == null) {
                console.warn('Registro sin activity.id, se omite:', record);
                return;
              }

              // Construyo el key inicial
              var layerKey = 'activity-' + baseId;
              // Si ya existe, le añado sufijo timestamp+índice para hacerlo único
              if (activitiesMap.has(layerKey)) {
                layerKey += '-' + Date.now() + '-' + idx;
              }

              // ✅ NUEVO: ahora guardamos puntos y linePoints por separado
              var entry = { name: name, points: [], linePoints: [] };

              // --- PUNTOS (pointsField) ---
              var ptsArr = record[pointsField];
              if (Array.isArray(ptsArr)) {
                ptsArr.forEach(function (pt) {
                  var lat = parseFloat(pt.latitude);
                  var lng = parseFloat(pt.longitude);
                  if (!isNaN(lat) && !isNaN(lng)) {
                    entry.points.push({
                      lat: lat,
                      lng: lng,
                      name: name,
                      hour: pt[hourField],
                    });
                  }
                });
              }

              // --- LÍNEA (lineField) ---
              var lineArr = record[lineField];
              if (Array.isArray(lineArr)) {
                lineArr.forEach(function (pt) {
                  var lat = parseFloat(pt.latitude);
                  var lng = parseFloat(pt.longitude);
                  if (!isNaN(lat) && !isNaN(lng)) {
                    entry.linePoints.push({
                      lat: lat,
                      lng: lng,
                      name: name,
                      hour: pt[hourField],
                    });
                  }
                });
              }

              // ✅ Opcional: ordenar por hora si viene (recomendado para líneas)
              if (sortByHour) {
                var byHour = function (a, b) {
                  return String(a.hour || '').localeCompare(
                    String(b.hour || '')
                  );
                };
                entry.points.sort(byHour);
                entry.linePoints.sort(byHour);
              }

              activitiesMap.set(layerKey, entry);
            });

            // Paleta de 9 colores RGB que se pueden ajustar
            var palette = [
              [255, 0, 0], // rojo
              [0, 255, 0], // verde
              [0, 0, 255], // azul
              [255, 165, 0], // naranja
              [128, 0, 128], // púrpura
              [0, 255, 255], // cian
              [255, 192, 203], // rosa
              [128, 128, 0], // oliva
              [0, 128, 128], // teal
            ];

            // 2) Asignar colores de la paleta sin repetir (secuencialmente)
            var colorMap = new Map();
            var i = 0;
            activitiesMap.forEach(function (_, layerKey) {
              var color = palette[i % palette.length];
              colorMap.set(layerKey, color);
              i++;
            });

            // 3) Crear GraphicsLayer por cada entrada en activitiesMap
            var layers = [];
            activitiesMap.forEach(function (entry, layerKey) {
              var layerColor = colorMap.get(layerKey);

              // IDs para puntos y línea
              var layerIdPts = 'pts-' + layerKey;
              var layerIdLine = 'line-' + layerKey;

              // --- Capa de puntos ---
              var ptsLayer = new GraphicsLayer({
                title: entry.name + ' (Puntos)',
                id: layerIdPts,
                visible: true,
              });

              entry.points.forEach(function (pt) {
                var ptColor = layerColor;

                // ✅ Mobile: todos los puntos azules
                if (isMobile) ptColor = MOBILE_COLORS.ptsBlue;

                ptsLayer.add(
                  new Graphic({
                    geometry: {
                      type: 'point',
                      longitude: pt.lng,
                      latitude: pt.lat,
                    },
                    symbol: {
                      type: 'simple-marker',
                      color: ptColor,
                      size: defaultSize,
                      outline: { color: [255, 255, 255], width: 1 },
                    },
                    attributes: { name: pt.name, date: pt.hour },
                    popupTemplate: {
                      title: 'Actividad: {name}',
                      content: 'Hora de muestra: {date}',
                    },
                  })
                );
              });

              // --- Capa de línea (polyline) ---
              var lineLayer = new GraphicsLayer({
                title: entry.name + ' (Línea)',
                id: layerIdLine,
                visible: false,
              });

              // ✅ NUEVO: usar linePoints si existe; si no, fallback a points (smartwatch)
              var sourceForLine =
                entry.linePoints && entry.linePoints.length
                  ? entry.linePoints
                  : entry.points;

              // ✅ Mobile: inicio/fin deben salir del recorrido (sourceForLine)
              if (isMobile && sourceForLine && sourceForLine.length) {
                var startPt = sourceForLine[0];
                var endPt = sourceForLine[sourceForLine.length - 1];

                // Inicio (verde)
                ptsLayer.add(
                  new Graphic({
                    geometry: {
                      type: 'point',
                      longitude: startPt.lng,
                      latitude: startPt.lat,
                    },
                    symbol: {
                      type: 'simple-marker',
                      color: MOBILE_COLORS.startGreen,
                      size: defaultSize + 4, // un poquito más grande para que destaque
                      outline: { color: [255, 255, 255], width: 2 },
                    },
                    attributes: {
                      name: entry.name,
                      date: startPt.hour,
                      type: 'start',
                    },
                    popupTemplate: {
                      title: 'Inicio: {name}',
                      content: 'Hora: {date}',
                    },
                  })
                );

                // Fin (rojo) -> lo agrego de último para que quede encima visualmente
                ptsLayer.add(
                  new Graphic({
                    geometry: {
                      type: 'point',
                      longitude: endPt.lng,
                      latitude: endPt.lat,
                    },
                    symbol: {
                      type: 'simple-marker',
                      color: MOBILE_COLORS.endRed,
                      size: defaultSize + 4,
                      outline: { color: [255, 255, 255], width: 2 },
                    },
                    attributes: {
                      name: entry.name,
                      date: endPt.hour,
                      type: 'end',
                    },
                    popupTemplate: {
                      title: 'Fin: {name}',
                      content: 'Hora: {date}',
                    },
                  })
                );
              }

              var path = sourceForLine.map(function (pt) {
                return [pt.lng, pt.lat];
              });

              // (evitar polyline vacía)
              if (path.length >= 2) {
                var lineColor = layerColor;
                if (isMobile) lineColor = MOBILE_COLORS.lineOrange;

                lineLayer.add(
                  new Graphic({
                    geometry: { type: 'polyline', paths: [path] },
                    symbol: {
                      type: 'simple-line',
                      color: lineColor,
                      width: 2,
                    },
                  })
                );
              }

              layers.push(ptsLayer);
              layers.push(lineLayer);
            });

            // Crear el mapa con las capas
            var map = new EsriMap({ basemap: basemap, layers: layers });
            if (!mapRef) {
              mapRef = this.$refs.map;
            }
            //Movemos la capa de lineas y la pone al fondo para que salga primero la de puntos
            map.layers.forEach((layer) => {
              if (layer.id.indexOf('line-') === 0) map.reorder(layer, 0); // al fondo
            });

            // Calcular centro en primer punto válido
            var center;
            if (layers.length && layers[0].graphics.items.length) {
              var firstGraphic = layers[0].graphics.items[0];
              center = [
                firstGraphic.geometry.longitude,
                firstGraphic.geometry.latitude,
              ];
            }

            // Instanciar MapView
            this.map = new MapView({
              container: mapRef,
              map: map,
              zoom: 14,
              center: center,
            });

            //Fullscreen Mode
            this.map.ui.add(
              new Fullscreen({
                view: this.map,
                element: mapRef,
              }),
              'top-left'
            );

            //Tipos de fondo
            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new BasemapGallery({
                  view: this.map,
                }),
              }),
              'top-left'
            );

            //Regresa al Home o punto central configurado
            this.map.ui.add(
              new Home({
                view: this.map,
              }),
              'top-left'
            );

            // LayerList
            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new LayerList({
                  view: this.map,
                }),
              }),
              'top-right'
            );

            // ScaleBar
            this.map.ui.add(
              new ScaleBar({
                view: this.map,
                unit: 'dual',
              }),
              'bottom-left'
            );

            // Botón “toggleView” con 3 estados
            const toggleBtn = document.createElement('button');
            toggleBtn.className =
              'esri-widget--button esri-widget esri-interactive esri-icon-chart';
            toggleBtn.title = 'Ver: Sólo puntos';

            // Modo 0 = puntos, 1 = líneas, 2 = ambos
            let viewMode = 0;

            toggleBtn.addEventListener('click', () => {
              viewMode = (viewMode + 1) % 3;

              let showPts, showLine;
              switch (viewMode) {
                case 0:
                  showPts = true;
                  showLine = false;
                  toggleBtn.title = 'Ver: Sólo puntos';
                  toggleBtn.className =
                    'esri-widget--button esri-widget esri-interactive esri-icon-map-pin';
                  break;
                case 1:
                  showPts = false;
                  showLine = true;
                  toggleBtn.title = 'Ver: Sólo líneas';
                  toggleBtn.className =
                    'esri-widget--button esri-widget esri-interactive esri-icon-polyline';
                  break;
                default:
                  showPts = true;
                  showLine = true;
                  toggleBtn.title = 'Ver: Puntos y líneas';
                  toggleBtn.className =
                    'esri-widget--button esri-widget esri-interactive esri-icon-chart';
                  break;
              }

              map.layers.forEach((layer) => {
                if (layer.id.indexOf('pts-') === 0) layer.visible = showPts;
                if (layer.id.indexOf('line-') === 0) layer.visible = showLine;
              });
            });

            const btnContainer = document.createElement('div');
            btnContainer.className = 'esri-widget esri-widget--button';
            btnContainer.appendChild(toggleBtn);
            this.map.ui.add(btnContainer, 'top-right');

            return this.map;
          }.bind(this)
        )
        .catch(function (error) {
          console.error('Error cargando módulos ArcGIS:', error);
        });
    },

    /**
     * Método para generar un mapa con lineas para graficar el tracking de un recorrido específico.
     * @param routesArray Array de puntos con estructura { latitude, longitude, altitude, full_date }
     * @param mapRef HTMLElement referencia al contenedor del mapa (this.$refs.map)
     * @param basemap string con estilo de mapa base (puede ser null)
     * @param options Object con opciones adicionales para el mapa (lineColor, lineWidth, pointColor, pointSize, showPoints, showLine, zoom)
     */
    loadRouteMap(routesData, mapRef, basemap, options) {
      // Validaciones
      if (!mapRef || !(mapRef instanceof HTMLElement)) {
        console.error(
          'loadRouteMap: ' + i18n.t('sigatoka.invalid_mapref'),
          mapRef
        );
        return;
      }
      if (!routesData || typeof routesData !== 'object') {
        console.error(
          'loadRouteMap: ' + i18n.t('sigatoka.expected_array'),
          routesData
        );
        return;
      }

      // Defaults
      basemap = basemap || 'hybrid';
      options = options || {};

      var lineColor = options.lineColor || [255, 165, 0];
      var lineWidth = options.lineWidth || 2;
      var showLine = options.showLine !== false;
      var zoom = options.zoom || 14;

      // Colores por tipo de captura
      const AGE_COLOR = [255, 140, 0]; // naranja — age plants
      const YOUNG_COLOR = [0, 180, 255]; // celeste — young plants
      const POINT_SIZE = 10;
      const START_COLOR = [0, 200, 0]; // verde
      const END_COLOR = [255, 0, 0]; // rojo
      const MARKER_SIZE = POINT_SIZE + 4;

      loadModules(
        [
          'esri/Map',
          'esri/views/MapView',
          'esri/Graphic',
          'esri/layers/GraphicsLayer',
          'esri/widgets/Expand',
          'esri/widgets/Fullscreen',
          'esri/widgets/ScaleBar',
          'esri/widgets/Home',
          'esri/widgets/LayerList',
          'esri/widgets/BasemapGallery',
        ],
        { css: true }
      )
        .then(
          function (modules) {
            var EsriMap = modules[0];
            var MapView = modules[1];
            var Graphic = modules[2];
            var GraphicsLayer = modules[3];
            var Expand = modules[4];
            var Fullscreen = modules[5];
            var ScaleBar = modules[6];
            var Home = modules[7];
            var LayerList = modules[8];
            var BasemapGallery = modules[9];

            //Parsea un punto y extrae la hora
            function parsePoint(pt) {
              var lat = parseFloat(pt.latitude);
              var lng = parseFloat(pt.longitude);
              if (isNaN(lat) || isNaN(lng)) return null;
              var hour = '';
              if (pt.full_date) {
                var d = new Date(pt.full_date.replace(' ', 'T'));
                if (!isNaN(d.getTime())) {
                  hour = d.toLocaleTimeString().slice(0, 8); // HH:MM:SS
                }
              }

              return {
                lat,
                lng,
                hour,
                altitude: pt.altitude || 0,
                plant: pt.plant || null,
                age: pt.age != null ? pt.age : null,
                lot: pt.lot || '',
              };
            }

            var makeRouteMarker = function (pt, color, label) {
              return new Graphic({
                geometry: {
                  type: 'point',
                  longitude: pt.lng,
                  latitude: pt.lat,
                },
                symbol: {
                  type: 'simple-marker',
                  color: color,
                  size: MARKER_SIZE,
                  outline: { color: [255, 255, 255], width: 2 },
                },
                attributes: {
                  title: label,
                  hour: pt.hour,
                },
                popupTemplate: {
                  title: label,
                  content: [
                    {
                      type: 'fields',
                      fieldInfos: [
                        {
                          fieldName: 'hour',
                          label: i18n.t('common_words.hour'),
                        },
                      ],
                    },
                  ],
                },
              });
            };

            function makeCaptureGraphic(pt, color) {
              if (pt.age != null)
                var ageLabel =
                  pt.age == 0
                    ? i18n.t('sigatoka.expecting')
                    : pt.age == 1
                    ? i18n.t('sigatoka.newly_given_birth')
                    : pt.age + ' ' + i18n.t('sigatoka.weeks');
              else var ageLabel = i18n.t('sigatoka.young_plant');
              var plantLabel = i18n.t('sigatoka.plant') + ': ' + pt.plant;

              return new Graphic({
                geometry: {
                  type: 'point',
                  longitude: pt.lng,
                  latitude: pt.lat,
                },
                symbol: {
                  type: 'simple-marker',
                  color: color,
                  size: POINT_SIZE,
                  outline: { color: [255, 255, 255], width: 1.5 },
                },
                attributes: {
                  title: ageLabel + '\n' + plantLabel,
                  lot: pt.lot || '',
                  hour: pt.hour,
                },
                popupTemplate: {
                  title: ageLabel + '<br>' + plantLabel,
                  content: [
                    {
                      type: 'fields',
                      fieldInfos: [
                        {
                          fieldName: 'lot',
                          label: i18n.t('common_words.allotment'),
                        },
                        {
                          fieldName: 'hour',
                          label: i18n.t('common_words.hour'),
                        },
                      ],
                    },
                  ],
                },
              });
            }

            var ages = (routesData.ages || []).map(parsePoint).filter(Boolean);
            var youngs = (routesData.youngs || [])
              .map(parsePoint)
              .filter(Boolean);

            var routes = (routesData.routes || [])
              .map(parsePoint)
              .filter(Boolean);

            var startPt = routes[0];
            var endPt = routes[routes.length - 1];

            var allCapturePoints = [...ages, ...youngs];
            if (allCapturePoints.length === 0 && routes.length === 0) {
              console.error(
                'loadRouteMap: ' + i18n.t('sigatoka.no_valid_point_array')
              );
              return;
            }

            var startEndLayer = new GraphicsLayer({
              title: i18n.t('common_words.start_end'),
              id: 'route-start-end',
              visible: true,
            });
            startEndLayer.add(
              makeRouteMarker(
                startPt,
                START_COLOR,
                i18n.t('common_words.route_start')
              )
            );
            startEndLayer.add(
              makeRouteMarker(
                endPt,
                END_COLOR,
                i18n.t('common_words.route_end')
              )
            );

            var ageLayer = new GraphicsLayer({
              title: i18n.t('sigatoka.other_plants'),
              id: 'age-plants',
              visible: true,
            });
            ages.forEach((pt) =>
              ageLayer.add(makeCaptureGraphic(pt, AGE_COLOR))
            );

            var youngLayer = new GraphicsLayer({
              title: i18n.t('sigatoka.young_plants'),
              id: 'young-plants',
              visible: true,
            });
            youngs.forEach((pt) =>
              youngLayer.add(makeCaptureGraphic(pt, YOUNG_COLOR))
            );

            var lineLayer = new GraphicsLayer({
              title: i18n.t('common_words.route_line'),
              id: 'route-line',
              visible: showLine,
            });

            var path = routes.map((pt) => [pt.lng, pt.lat]);
            if (path.length >= 2) {
              lineLayer.add(
                new Graphic({
                  geometry: { type: 'polyline', paths: [path] },
                  symbol: {
                    type: 'simple-line',
                    color: lineColor,
                    width: lineWidth,
                  },
                })
              );
            }

            var map = new EsriMap({
              basemap,
              layers: [lineLayer, startEndLayer, ageLayer, youngLayer],
            });

            var firstPt = allCapturePoints[0] || routes[0];
            var center = [firstPt.lng, firstPt.lat];

            this.map = new MapView({
              container: mapRef,
              map,
              zoom,
              center,
            });

            this.map.ui.add(
              new Fullscreen({ view: this.map, element: mapRef }),
              'top-left'
            );
            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new BasemapGallery({ view: this.map }),
              }),
              'top-left'
            );
            this.map.ui.add(new Home({ view: this.map }), 'top-left');
            this.map.ui.add(
              new Expand({
                view: this.map,
                content: new LayerList({ view: this.map }),
              }),
              'top-right'
            );
            this.map.ui.add(
              new ScaleBar({ view: this.map, unit: 'dual' }),
              'bottom-left'
            );

            return this.map;
          }.bind(this)
        )
        .catch(function (error) {
          console.error(
            'loadRouteMap: ' + i18n.t('sigatoka.error_loading_arcgis_modules'),
            error
          );
        });
    },
  },
};

export default MixinArcgisMap;
